<template>
  <div>
    <div
      v-if="addOns.length"
      class="my-3"
    >
      <ejs-grid
        :data-source="addOns"
        :toolbar="toolbarOptions"
        :allow-paging="true"
        :allow-filtering="true"
        :page-settings="pageSettings"
        :filter-settings="filterOptions"
        :allow-sorting="true"
        clip-mode="EllipsisWithTooltip"
      >
        <e-columns>
          <e-column
            field=" "
            header-text=""
            width="80"
            :template="selectTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          />
          <e-column
            field="name"
            header-text="Name"
            width="130"
            :template="nameTemplate"
          />
          <e-column
            field="type"
            header-text="Type"
            width="50"
          />
          <!-- Mariano: I wont remove it in case they want to reincorporate this feature. -->
          <!-- <e-column
            field="preview"
            header-text=""
            width="80"
            :template="previewTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          /> -->
        </e-columns>
      </ejs-grid>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { GridPlugin, Toolbar, Search, Page, Sort, Filter } from '@syncfusion/ej2-vue-grids'
import { createElement } from '@syncfusion/ej2-base'
import { TextBox } from '@syncfusion/ej2-inputs'
import GridSelect from './GridSelect'
import GridName from './GridName'
import GridPreview from './GridPreview'
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns'

Vue.use(GridPlugin)
MultiSelect.Inject(CheckBoxSelection)

export default {
  provide () {
    return {
      grid: [Toolbar, Search, Filter, Sort, Page],
      onClick: this.onSelect
    }
  },
  data () {
    return {
      pageSettings: { pageCount: 5, pageSize: 10, pageSizes: ['10', '25', '50', '100'] },
      filterOptions: {
        type: 'Menu',
        mode: 'OnEnter',
        operators: {
          stringOperator: [
            { value: 'startsWith', text: 'Starts With' },
            { value: 'endsWith', text: 'Ends With' },
            { value: 'contains', text: 'Contains' },
            { value: 'equal', text: 'Equal' }
          ]
        }
      },
      filter: {
        type: 'CheckBox'
      },
      toolbarOptions: ['Search'],
      customFilter: {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            this.dropInstance = new TextBox({
              placeholder: 'Enter the value'
            })
            this.dropInstance.appendTo(flValInput)
            this.$helpers.setFilterId(this.dropInstance.element)
          },
          write: (args) => {
            if (args.filteredValue) {
              this.dropInstance.value = args.filteredValue
            }
          },
          read: (args) => {
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value,
              false
            )
          }
        }
      },
      selectTemplate () {
        return {
          template: {
            extends: GridSelect
          }
        }
      },
      nameTemplate () {
        return {
          template: {
            extends: GridName
          }
        }
      },
      previewTemplate () {
        return {
          template: {
            extends: GridPreview
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      grapesJSInstance: 'getGrapesJSInstance',
      dynamicContent: 'getDynamicContent',
      addOns: 'getAddOns'
    })
  },
  mounted () {
    const userEmail = this.$route.query.userEmail ? atob(this.$route.query.userEmail) : ''
    const response = this.getAddOns({ clientId: this.$route.query.clientId, companyId: this.$route.query.externalId, userEmail })
    response
      .then(({ success }) => {
        if (success) {
          this.data = success
        }
      })
      .catch(err => {
        console.log(err)
      })
  },
  methods: {
    ...mapActions([
      'getAddOns'
    ]),
    onSelect (result, type) {
      // if the grapeJS Instance is null, then copying the text for drag n drop
      if (this.grapesJSInstance === null) {
        this.legacyCopyToClipboard(result)
        this.dynamicContent.modalRef.closeDialog()
      } else {
        this.grapesJSInstance.InsertMoreOptData({
          action: 'InsertMoreOptData',
          type: type,
          value: result,
          moreoption: true
        })
        this.dynamicContent.modalRef.closeDialog()
      }
    },
    legacyCopyToClipboard (text) {
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()
      try {
        document.execCommand('copy')
      } catch (err) {
        console.error('Unable to copy to clipboard', err)
      }
      document.body.removeChild(textArea)
    },
    getSectionFilter () {
      return this.getArrayFilter('Select a section', 'sections')
    },
    getArrayFilter (placeHolder, propertyName) {
      return {
        ui: {
          create: (args) => {
            const flValInput = createElement('input', {
              className: 'flm-input'
            })
            args.target.appendChild(flValInput)
            if (args.target.parentElement.children) {
              args.target.parentElement.children[0].style.display = 'none'
              args.target.parentElement.children[1].style.paddingTop = '0px'
            }
            this.dropInstance = new MultiSelect({
              dataSource: this[propertyName],
              fields: {
                text: 'name',
                value: 'id'
              },
              placeholder: placeHolder,
              popupHeight: '200px',
              mode: 'CheckBox'
            })
            this.dropInstance.value = this.dropInstance.value || []
            this.dropInstance.appendTo(flValInput)
          },
          write: (args) => {
            let arr = []
            if (
              args.parent.filterModule.actualPredicate
                .tags !== undefined
            ) {
              arr = args.parent.filterModule.actualPredicate.tags.map(
                (element) => element.value
              )
            }
            this.dropInstance.value = Array.isArray(args.filteredValue)
              ? args.filteredValue
              : arr
          },
          read: (args) => {
            args.fltrObj.filterSettings.columns = args.fltrObj.filterSettings.columns.filter(
              (x) => {
                return x.field !== args.column.field
              }
            )
            args.fltrObj.filterByColumn(
              args.column.field,
              args.operator,
              this.dropInstance.value
            )
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
